import config from "./../config/config.json";
import http from "./httpService";

const apiEndpoint = config.apiUrl + "/workinstructions";

function workinstructionUrl(id) {
  return `${apiEndpoint}/${id}`;
}

export function getWorkInstructions() {
  return http.get(apiEndpoint);
}

export function getWorkinstruction(Id) {
  return http.get(workinstructionUrl(Id));
}

export function saveWorkinstruction(workinstruction) {
  if (workinstruction._id) {
    const body = { ...workinstruction };
    delete body._id;
    return http.put(workinstructionUrl(workinstruction._id), body);
  }
  return http.post(apiEndpoint, workinstruction);
}

export function deleteWorkinstruction(Id) {
  return http.delete(workinstructionUrl(Id));
}

export function softDeleteWorkinstruction(Id, workinstruction) {
  return http.put(workinstructionUrl(Id), workinstruction);
}

export function restoreWorkinstruction(Id, workinstruction) {
  return http.put(workinstructionUrl(Id), workinstruction);
}
